module.exports = __webpack_public_path__ + "img/shapelog_team.fe22acbd.png";